export var DEF_GLOBAL_PREFIX = 'G_GOV_';
export function getGlobalConfig(key, prefix) {
  if (prefix === void 0) {
    prefix = DEF_GLOBAL_PREFIX;
  }

  if (!key) return null;
  var fullKey = "" + prefix + key;
  return window[fullKey];
}
export function siteConfig(key, prefix) {
  if (prefix === void 0) {
    prefix = DEF_GLOBAL_PREFIX;
  }

  var config = getGlobalConfig('siteConfig', prefix);
  if (!config) return config;

  if ({}.toString.call(config) !== '[object Object]') {
    return config;
  }

  return config[key];
}